import { ReactElement, useEffect } from 'react';
import { UISubNav, useUINav } from '@/ui';
import { useAccountSettings } from './provider';
import { EmailSettingsSection, ChangeEmailSection } from '@/me/components';
import { usePagesTranslation } from '../hooks';

export function EmailSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.account')
            },
            { text: t('shared.labels.email_address') }
        ]);
    }, [setParts, t]);

    const {
        data: { user }
    } = useAccountSettings();

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 32,
                gap: 24
            }}
        >
            <UISubNav title={t('shared.labels.email_address')} />
            <EmailSettingsSection user={user} />
            <ChangeEmailSection />
        </div>
    );
}
